import React from "react";
import { DA_Select } from "@danishagro/shared/src/components/atoms/Select/Select.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import S from "./SortOrder.module.scss";

interface SortOrderProps {
    sortOrder: string;
    onChangeSortOrder: (sortOrder?: string) => void;
}

export const SortOrder: React.FC<SortOrderProps> = ({ sortOrder, onChangeSortOrder }) => {
    const { getDictionaryString } = useTranslations();

    const sortOptions = [
        { label: getDictionaryString("profile.orderHistory.sortOrder.newestFirst"), value: "DESC" },
        { label: getDictionaryString("profile.orderHistory.sortOrder.oldestFirst"), value: "ASC" },
    ];

    return (
        <div className={S.toolbar}>
            <div>
                <div className={S.title}>
                    {getDictionaryString("profile.orderHistory.sortOrder")}
                </div>
                <div>
                    <DA_Select
                        className={S.sortSelect}
                        ariaLabel={getDictionaryString("profile.orderHistory.sortOrder")}
                        options={sortOptions}
                        value={sortOrder}
                        onChange={(option) => {
                            onChangeSortOrder(option.value);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
